<template>
  <b-modal :id="id"
           :size="size"
           :body-class="bodyClass">
    <template #modal-title>
      <slot name="heading" />
    </template>
    <slot name="content" />
    <template #modal-footer="{ok, close}">
      <button v-if="!okOnly"
              type="button"
              class="btn"
              :class="{closeButtonVariant}"
              @click="close()">
        Close
      </button>
      <button v-if="!closeOnly"
              type="button"
              class="btn"
              :class="{okButtonVariant}"
              @click="ok()">
        OK
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "DefaultModal",
  props: {
    id: {
      type: String,
      required: true,
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    closeOnly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: undefined,
    },
    bodyClass: {
      type: String,
      default: undefined,
    },
    closeButtonVariant: {
      type: String,
      default: "",
    },
    okButtonVariant: {
      type: String,
      default: "btn-accent-1",
    },
  },
};
</script>

<style lang="less">
@import "../../Styles/utils/colors.less";

.modal {

  &-content {
    border: none;
    box-shadow: 0 0 5px 0 rgba( 0, 0, 0, 0.2 );
    border-radius: 5px;
  }

  &-header {
    border-top: none;
    background-color: @color-accent-1;

    .close {
      text-shadow: none;
    }
  }

  &-title {
    color: #fff;
  }

  &-footer {
    background-color: #fff;
  }

}
</style>
